var turner_metadata = {
    section: ["albums","unknown"],
    template_type: "adbp:section front",
    content_type: "adbp:none"
}

class App {
    constructor() {
        //do not play tracks that have not been released
        if (window.active == undefined || window.active === true) {
            this.initAudio();
            this.initUI();
            this.eventHandler();
            if (!window.singles) this.shareHandler(); //singles uses its own shareHandler in the pug view
            this.loadAudio();
        }
    }

    initUI() {
        let self = this;

        this.controls = {
            share: document.querySelector('#share'),
            share_dismiss: document.querySelector('#share-dismiss'),
            play: document.querySelector('#play'),
            pause: document.querySelector('#pause'),
            seek: document.querySelector('#seek-progress'),
            progress: document.querySelector('#track-progress'),
            current: document.querySelector('#time-current'),
            duration: document.querySelector('#time-duration')
        };

        this.shareControls = {
            facebook: document.querySelector('#fb-share'),
            twitter: document.querySelector('#tw-share'),
            tumblr: document.querySelector('#tb-share'),
            mail: document.querySelector('#mail-share'),
        };

        self.controls.duration.textContent = trackCounter(self.audio.duration.toString()); //back up if metadata is not loaded?

        this.controls.share.onclick = () => {
            $("#share-overlay").addClass('active');
        };

        this.controls.share_dismiss.onclick = () => {
            $("#share-overlay").removeClass('active');
        };

        this.controls.play.onclick = () => {
            if (!self.playing && self.audioReady) {
                self.audio.play();
                self.playing = true;
            }
        };
        this.controls.pause.onclick = () => {
            if (self.playing && self.audioReady) {
                self.audio.pause();
                self.playing = false;
            } 
        };
    }

    eventHandler() {
        let self = this;

        this.title = document.getElementById('title');
        if (!window.singles) this.shareAlbumTitle = document.getElementById('album-title'); //this element does not exist on singles embed players

        var marquee = $('.track-section-title');
        marquee.each(function() {
            var mar = $(this),indent = 0;
            mar.marquee = function() {
                indent--;
                mar.css('text-indent',indent);
                if (indent < -1 * mar.children('#title').width()) {
                    indent = mar.width() - 100;
                }
            };
            mar.data('interval',setInterval(mar.marquee,2750/60));
        });

        this.audio.addEventListener('play', function(event) {
            console.log(self.audio.getAttribute('data-tracking'));
            self.playing = true;
            if(self.firstTimePlaying) {
                self.tracking('embed music player:'+ self.audio.getAttribute('data-tracking') + ':play button clicked');
                self.firstTimePlaying = false;
            }

            $('#pause').show();
            $('#play').hide();
        });

        this.audio.addEventListener('pause', function(event) {
            $('#play').show();
            $('#pause').hide();
        });

        this.audio.addEventListener('timeupdate', function (event) {
            let duration = self.audio.duration;
            let currentTime = self.audio.currentTime;
            let position = ((currentTime/duration)*100);
            self.controls.current.textContent = trackCounter(self.audio.currentTime.toString());
            self.controls.progress.style.width = position + "%";
        });

        this.audio.addEventListener('ended', () => {
            self.audio.currentTime = 0;
            self.audio.pause();
            self.loadAudio();
        });

        this.controls.seek.onclick = (event) => {
            if (self.playing && self.audioReady) {
                var percent = event.offsetX / this.controls.seek.offsetWidth;
                self.audio.currentTime = percent * self.audio.duration;
            }
        };
    }

    shareHandler() {
        let self = this;
        var track = document.getElementById('track-name').innerHTML;
        var artist = document.getElementById('track-artist').innerHTML;

        if (!track || !artist || track === '' || artist === '') {
            populateError();
        }

        if (!window.singles) {
            window.share.find(function(el){
                if (el._group === 'facebook') {
                    self.facebook = el;
                    return true;
                }
            })
            window.share.find(function(el){
                if (el._group === 'twitter') {
                    self.twitter = el;
                    return true;
                }
            })
            window.share.find(function(el){
                if (el._group === 'tumblr') {
                    self.tumblr = el;
                    return true;
                }
            })
            window.share.find(function(el){
                if (el._group === 'mail') {
                    self.mail = el;
                    return true;
                }
            })
        }

        // Social Click Events
        if (this.shareControls.facebook) {
            this.shareControls.facebook.onclick = (event) => {
                self.tracking('Facebook share clicked while listening to ' + artist + ' : ' + track);
                self.trackingSocial('Facebook share clicked while listening to ' + artist + ' : ' + track);

                var url = 'https://www.facebook.com/sharer/sharer.php?u=' + this.facebook.url.value;
                window.open(url, 'binaryshare', 'menubar=no,width=600,height=400');
            };
        }

        if (this.shareControls.twitter) {
            this.shareControls.twitter.onclick = (event) => {
                self.tracking('Twitter share clicked while listening to ' + artist + ' : ' + track);
                self.trackingSocial('Twitter share clicked while listening to ' + artist + ' : ' + track);

                var url = 'https://twitter.com/share?';
                url += '&text=' + encodeURIComponent(this.twitter.text.value);
                url += '&url=' + this.twitter.url.value;
                url += '&via=adultswim';
                window.open(url, 'binaryshare', 'menubar=no,width=600,height=400');
            };
        }

        if (this.shareControls.tumblr) {
            this.shareControls.tumblr.onclick = (event) => {
                self.tracking('Tumblr share clicked while listening to ' + artist + ' : ' + track);
                self.trackingSocial('Tumblr share clicked while listening to ' + artist + ' : ' + track);

                var url = 'https://www.tumblr.com/widgets/share/tool/preview?posttype=link&canonicalUrl=';
                url += encodeURIComponent(this.tumblr.url.value);
                url += '&title=' + encodeURIComponent(this.tumblr.title.value);
                url += '&content=' + encodeURIComponent(this.tumblr.url.value);
                url += '&caption=' + encodeURIComponent(this.tumblr.caption.value);
                url += '&tags=' + encodeURIComponent(this.tumblr.tags.value);
                url += '&shareSource=umblr_share_button&_format=html';
                window.open(url, 'binaryshare', 'menubar=no,width=600,height=400');   
            };
        }

        if (this.shareControls.mail) {
            this.shareControls.mail.onclick = (event) => {
                self.tracking('Email share clicked while listening to ' + artist + ' : ' + track);
                self.trackingSocial('Email share clicked while listening to ' + artist + ' : ' + track);

                var url = "mailto:?Subject=" + this.mail.subject.value + "&body=" + this.mail.body.value;
                window.open(url, 'binaryshare', 'menubar=no,width=600,height=400');
            };
        }
    }

    initAudio() {
        let self = this;

        this.firstTimePlaying = true;
        this.audio = document.getElementById('embedded');
        this.audio.addEventListener('loadedmetadata', function() {
            self.controls.duration.textContent = trackCounter(self.audio.duration.toString());
        });
    }

    loadAudio() {
        this.controls.progress.style.width = "0%";

        let self = this;

        if (self.playing && self.audioReady) {
            this.audio.pause();
        }

        this.audioReady = false;
        this.playing = false;

        self.playAudio();
    }

    playAudio() {
        this.audioReady = true;
    }

    tracking(data) {
        try {
            window.trackMetrics({
                'type': "promo-interaction",
                'data': {
                    'promo_interaction_name': data
                }
            });
        } catch (e) {
            console.log('JSMD Error:', e);
        }
    }

    trackingSocial = function(data) {
        try {
            window.trackMetrics({
                'type': 'social-click',
                'data': {
                    'social_name': data
                }
            });
        } catch (e) {
            console.log('JSMD Error:', e);
        }
    }
}

// Takes an integer, seconds, and returns the duration as "[Minutes]:[Seconds]"
function trackCounter(secs) {
    var hour = Math.floor((secs / 3600));
    var min = Math.floor((secs % 3600) / 60);
    var sec = Math.floor(secs % 60);

    if (sec < 10) {
        sec = "0" + sec;
    }
    if (hour > 0) {
        if (min < 10) {
            min = "0" + min;
        }
        return hour + ':' + min + ':' + sec;
    }

    return min + ':' + sec;
}
      
window.onload = () => {
    let url = $('#embedded').attr('data-src');
    if (document.getElementById('album-title')) turner_metadata.section = ["albums", document.getElementById('album-title').innerHTML];

    if (url) {
        var xhr = new XMLHttpRequest();
        
        xhr.addEventListener('load', function(blob) {
            if (xhr.status == 200) {
                $('#embedded').attr('src',window.URL.createObjectURL(new Blob([xhr.response], {type: 'audio/mpeg'})));
                new App(); //this is initiates the app
            }
        });

        xhr.onerror = function(e) {
            // this means there was likely a cors error but we should initialize the embed player anyway
            new App();
        }
        
        xhr.open('GET', url);
        if (url.includes('media.cdn.adultswim.com')) xhr.setRequestHeader('as-music-token', 'ZnVjayB0cnVtcA==') //this is for getting mp3 files which are in media.cdn.adultswim.com
        xhr.responseType = 'blob';
        xhr.send(null);
    } 
    else {
        new App();
    }
};

function populateError() {
    document.getElementById('title').textContent = "Track Not Found";
}

// This method is no longer necessary
// ****** 
// function getUrlParameter(sParam) {
//     var sPageURL = decodeURIComponent(window.location.search.substring(1)),
//         sURLVariables = sPageURL.split('&'),
//         sParameterName,
//         i;

//     for (i = 0; i < sURLVariables.length; i++) {
//         sParameterName = sURLVariables[i].split('=');

//         if (sParameterName[0] === sParam) {
//             return sParameterName[1] === undefined ? true : sParameterName[1];
//         }
//     }
// }